import { Routes, Route, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import "./index.css";
import { GlobalContext } from "./contexts/GlobalContext";
import { rootMenu } from "./data";
import Home from "./components/Home";
import Main from "./components/Main";
import client from "./client";

const findMenu = (menu, link) => {
	if (menu.link == link) {
		return menu;
	} else if (menu.menus) {
		for (let subMenu of menu.menus) {
			let found = findMenu(subMenu, link);
			if (found) {
				return found;
			}
		}
	}
	return null;
};

const getTextWidth = (text, font, fontSize) => {
	let span = document.createElement("span");
	document.body.appendChild(span);
	span.style.fontFamily = font;
	span.style.fontSize = fontSize + "px";
	span.style.height = "auto";
	span.style.width = "auto";
	span.style.position = "absolute";
	span.style.whiteSpace = "no-wrap";
	span.innerHTML = text;

	let width = Math.ceil(span.clientWidth);
	document.body.removeChild(span);
	return width;
};

/* const createRoute = (menu,Element,key) => {
    let route = null;
    if(menu.menus) {
      route = <Route key={key} path={menu.link} element={<Element/>}>
                  {menu.menus.map((submenu,i) =>
                      createRoute(submenu,Element,key+i)
                  )}
              </Route>
    } else if(menu.itemLink) {
      route = <Route key={key} path={menu.link} element={<Element/>}>
                <Route key={key+1} path={menu.itemLink} element={<Element/>}/>
            </Route>
    } else {
      route = <Route key={key} path={menu.link} element={<Element/>}/>
    }
    return route;
} */

const createRoute = (menu, key) => {
	if (!menu) return null;

	if (menu.menus) {
		if (menu.Element) {
			return (
				<Route
					key={`${menu.name}_${key}`}
					path={menu.link}
					element={<menu.Element />}
				>
					{menu.menus.map((submenu, i) =>
						createRoute(submenu, `${key}-${i}`),
					)}
				</Route>
			);
		}

		return menu.menus.map((submenu, i) =>
			createRoute(submenu, `${key}-${i}`),
		);
	}

	if (menu.Element) {
		return (
			<Route
				key={`${menu.name}_${key}`}
				path={menu.link}
				element={<menu.Element />}
			/>
		);
	}

	return null;
};

function App() {
	const [loading, setLoading] = useState(false);
	const [screenSize, setScreenSize] = useState("lg");
	const [editing, setEditing] = useState(false);
	const [version, setVersion] = useState(0);
	const [slideData, setSlideData] = useState([]);
	const [news, setNews] = useState([]);
	const { request, download } = client;

	useEffect(() => {
		request("GET", "slides")
			.then(async (response) => {
				if (response && response.length > 0) {
					for (let slide of response) {
						if (slide.ref && slide.ref.id) {
							await download(`slides/file/${slide.ref.id}`)
								.then((response) => {
									if (
										response &&
										response.data instanceof Blob
									) {
										slide.file = response.data;
									}
								})
								.catch((error) => {
									console.log(error);
								});
						}
					}
					setSlideData(response);
				} else {
					setSlideData([]);
				}
			})
			.catch((error) => {
				console.log(error);
			});

		/* request("GET","newsitems")
      .then( async (response) => {
          if(response && response.length > 0) {
              for(let newsItem of response) {
                  if(newsItem.ref && newsItem.ref.id) {
                      await download(`newsitems/file/${newsItem.ref.id}`)
                      .then((response) => {
                          if(response && response.data instanceof Blob) {
                              newsItem.file = response.data;
                          }
                      })
                      .catch((error) => {
                          console.log(error)
                      })
                  }
                  newsItem.date = newsItem.date?new Date(newsItem.date):null;
              }

              const sortedNews = [...response].sort(
                  (a, b) => b.date - a.date
              );
              setNews(sortedNews);
          } else {
              setNews([]);
          }
      })
      .catch((error) => {
          console.log(error)
      }) */
		request("GET", "news-items")
			.then((response) => {
				if (response && response.length > 0) {
					const newsItems = response
						.map((newsItem) => ({
							...newsItem,
							date: newsItem.date
								? new Date(newsItem.date)
								: null,
							file: null,
							loading: !!(newsItem.ref && newsItem.ref.id),
						}))
						.sort((a, b) => b.date - a.date);

					// Show news immediately
					setNews(newsItems);

					// Start downloading images independently
					newsItems.forEach((newsItem) => {
						if (newsItem.ref && newsItem.ref.id) {
							download(`news-items/file/${newsItem.ref.id}`)
								.then((response) => {
									if (
										response &&
										response.data instanceof Blob
									) {
										setNews((currentNews) =>
											currentNews.map((item) =>
												item.ref?.id === newsItem.ref.id
													? {
															...item,
															file: response.data,
															loading: false,
														}
													: item,
											),
										);
									}
								})
								.catch((error) => {
									console.log(error);

									setNews((currentNews) =>
										currentNews.map((item) =>
											item.ref?.id === newsItem.ref.id
												? {
														...item,
														loading: false,
													}
												: item,
										),
									);
								});
						}
					});
				} else {
					setNews([]);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, [version]);

	useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			for (let entry of entries) {
				let rect = entry.target.getBoundingClientRect();
				if (rect.width > 1024) {
					setScreenSize("lg");
				} else if (rect.width > 640) {
					setScreenSize("sm");
				} else {
					setScreenSize("xs");
				}
			}
		});
		observer.observe(document.documentElement);
		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div className="flex bg-white bg-cover bg-center w-full">
			<GlobalContext.Provider
				value={{
					screenSize,
					loading,
					setLoading,
					editing,
					setEditing,
					version,
					setVersion,
					slideData,
					news,
				}}
			>
				<Routes>{createRoute(rootMenu, 1)}</Routes>
			</GlobalContext.Provider>
		</div>
	);
}

export default App;
